import React from 'react';
import Block from './Block';
import PillTag from './PillTag';

// Whether a tool error message must stay out of the transcript. The server decides
// (block_redaction): in production a staff viewer gets the detail flagged
// `console_only`, everyone else an empty payload. Under DEBUG it renders as-is.
export const isHiddenError = (payload) =>
  payload?.block_type === 'error'
  && (!payload.block_data?.message || Boolean(payload.block_data.console_only));

const ErrorBlock = ({ blockData = {} }) => (
  <Block
    icon="alert-triangle"
    title={`Tool error${blockData.tool ? ` · ${blockData.tool}` : ''}`}
    accent="var(--error-500)"
    badge={<PillTag tone="error" dot>Failed</PillTag>}
  >
    <div style={{ fontSize: 13, color: 'var(--fg)', lineHeight: 1.5 }}>
      {blockData.message || 'Something went wrong while running this tool.'}
    </div>
  </Block>
);

export default ErrorBlock;
